import Loader from "components/loader"
import { UseQueryResult } from "@tanstack/react-query"
import { IPresence } from "../../types"

const Interventions: React.FC<{
  member: UseQueryResult<IPresence["member"]>
}> = ({ member }) => {
  return (
    <>
      {member.isLoading ? (
        <Loader />
      ) : (
        <div
          className="noStylesReset"
          dangerouslySetInnerHTML={{
            __html: member.data?.recommended_intervention!,
          }}
        />
      )}
    </>
  )
}

export default Interventions
